import { usePartnerPlaylistStore } from '~~/stores/partnerplaylist'

export default function usePartnerPlaylistList() {
  const playlistStore = usePartnerPlaylistStore()

  const playlists = computed(() => playlistStore.state.playlists)

  const fetchPartnerPlaylists = () => {
    playlistStore.fetchPartnerPlaylists()
  }

  return { playlists, fetchPartnerPlaylists }
}
